import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Music, Lock } from "lucide-react";

/**
 * "Story Track" — shows soundtrack tracks paired with a specific toolkit.
 * If user doesn't own the soundtrack, teases title/artist and links to unlock.
 */
const SuggestedTracks = ({ toolkitId, variant = "full" }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!toolkitId) return;
    api.get(`/toolkit/${toolkitId}/suggested-tracks`)
      .then(({ data }) => setData(data))
      .catch(() => setData({ tracks: [], owns_soundtrack: false }));
  }, [toolkitId]);

  if (!data || data.tracks.length === 0) return null;

  const owns = data.owns_soundtrack;

  return (
    <div className={`card-surface p-6 ${variant === "compact" ? "" : "p-6 md:p-8"}`} data-testid="suggested-tracks">
      <div className="flex items-center gap-2 mb-4">
        <div className="p-2 rounded-lg bg-teal-500/10 border border-teal-500/30">
          <Music size={14} className="text-teal-300" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-teal-300/80">Reading track</div>
          <div className="text-sm text-neutral-400">Music paired with this toolkit</div>
        </div>
      </div>

      <ul className="space-y-2">
        {data.tracks.map((t) => (
          <li key={t.id} className="flex items-start gap-3 py-2 border-b border-neutral-800 last:border-0" data-testid={`suggested-track-${t.id}`}>
            <div className="flex-1 min-w-0">
              <div className="text-neutral-100">
                <span className="font-display">{t.title}</span>
                <span className="text-neutral-500 text-sm"> — {t.artist}</span>
              </div>
              {owns && t.note && (
                <p className="text-sm text-neutral-300 italic mt-1">"{t.note}"</p>
              )}
              {!owns && (
                <p className="text-xs text-neutral-500 mt-1 inline-flex items-center gap-1">
                  <Lock size={10} /> Notes unlocked with The Soundtrack
                </p>
              )}
            </div>
            <span className="text-xs uppercase tracking-widest text-teal-300/80">{t.mood}</span>
          </li>
        ))}
      </ul>

      {!owns && (
        <div className="mt-4 pt-4 border-t border-neutral-800">
          <Link to="/soundtrack/preview" data-testid="suggested-unlock-link" className="text-sm text-teal-300 hover:text-teal-200">
            Unlock the full soundtrack + track-by-track notes →
          </Link>
        </div>
      )}
    </div>
  );
};

export default SuggestedTracks;
